<div class="background-linear">
<div class="how-it-works-area-container">
  <div class="cards-container">
    <div class="card-item" *ngFor="let item of items; let i = index">
      <div class="number">
        <strong>
          {{i+1}}
        </strong>
      </div>
      <div class="header">
        <strong>
          {{item.title}}
        </strong>
      </div>
      <div class="body" [innerHTML]="item.text | safeHTML">
      </div>
    </div>
  </div>
</div>
</div>
